import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { PeptideTherapyEdComponent } from '@consultation-upsells/peptide-therapy/ed/peptide-therapy-ed.component';
import { PeptideTherapyHairLossComponent } from '@consultation-upsells/peptide-therapy/hair-loss/peptide-therapy-hair-loss.component';
import { PeptideTherapyComponent } from '@consultation-upsells/peptide-therapy/peptide-therapy.component';
import { PeptideTherapyTrtComponent } from '@consultation-upsells/peptide-therapy/trt/peptide-therapy-trt.component';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { ConsultationStorageService } from '@services/consultation-storage.service';

/**
 * Switcher component that dynamically displays the appropriate Peptide Therapy upsell component based on the
 * consultation treatment type.
 */
@Component({
  selector: 'app-peptide-therapy-switcher',
  standalone: true,
  imports: [
    CommonModule,
    PeptideTherapyComponent,
    PeptideTherapyEdComponent,
    PeptideTherapyTrtComponent,
    PeptideTherapyHairLossComponent,
  ],
  templateUrl: './peptide-therapy-switcher.component.html',
})
export class PeptideTherapySwitcherComponent {
  public readonly ConsultationTreatmentTypes: typeof ConsultationTreatmentTypes = ConsultationTreatmentTypes;

  private consultationStorageService = inject(ConsultationStorageService);

  /**
   * Gets the current treatment type from the consultation storage service.
   */
  public get treatmentType(): ConsultationTreatmentTypes {
    return this.consultationStorageService.treatmentType;
  }
}
